import { ComponentsImports } from '../model/ComponentsImports';

const components: ComponentsImports = {
  Render: () => import('@shared/app/ui/Render.vue'),
  Status: () => import('@shared/app/ui/Status.vue'),
  Mock: () => import('@shared/app/ui/Mock.vue'),
  GitlabIssue: () => import('@shared/app/ui/GitlabIssue.vue'),
  Audio: () => import('@shared/app/ui/Audio.vue'),
};

export default components;
